import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Tutorial() {
  return (
    <div>
      <Paragraph size="2">
        The <em>API tutorial</em> refers to the practice exercise in the{' '}
        <Link variant="minimal" href="https://developer.vimeo.com/api/guides/start">
          Getting Started: The Basics
        </Link>{' '}
        guide.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
